import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from "react";
import { useRootSelector } from "../stateSelectors";
import { activeInputSelector, setActiveInput as setActiveInputAction } from "../slices/commonSlice";
import { useCommonDispatch } from "../../createRootReducer";
export const InputContext = React.createContext(null);
function setActiveInputThunk(d) {
    return (dispatch, getState) => {
        const value = typeof d === "function" ? d(activeInputSelector(getState())) : d;
        dispatch(setActiveInputAction(value));
    };
}
export const InputContextProvider = ({ children }) => {
    const dispatch = useCommonDispatch();
    const activeInput = useRootSelector(activeInputSelector);
    const setActiveInput = useCallback((d) => {
        dispatch(setActiveInputThunk(d));
    }, [dispatch]);
    const value = { activeInput, setActiveInput };
    return _jsx(InputContext.Provider, { value: value, children: children });
};
export const useInputContext = () => {
    const contextValue = React.useContext(InputContext);
    if (contextValue === null) {
        throw new Error("useInputContext must be used within a InputContextProvider");
    }
    return contextValue;
};
//# sourceMappingURL=inputContext.js.map